import React, { Component } from 'react';
import { Table, Input, Button, DatePicker, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import UpdateScore from './UpdateScore';
import API_URL from '../../../common/url';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    state = {
        maxMonth: '',
        searchParams: {}
    }

    componentDidMount() {
        this.queryDate();
    }

    queryDate = () => {
        const options = {
            url: API_URL.user.queryPmScoreGradeDate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { date } = res;
                const { searchParams } = this.state;
                searchParams.inspectionTime = date;
                const maxMonth = date;
                this.setState({
                    maxMonth,
                    searchParams,
                }, () => {
                    this.search();
                });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({...searchParams});
    }

    export = () => {
        this.props.export();
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleDatePickerChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        searchParams[key] = dateString;
        this.setState({ searchParams });
    }

    disabledDate = (current) => {
        const { maxMonth } = this.state;
        return current && current.valueOf() >= moment(maxMonth).add(1, 'M').valueOf();
    }

    render() {
        const { canSynchronize, synchronizeUser } = this.props;
        const { searchParams: { inspectionTime, employeeCode, userCompellation } } = this.state;
        const newInspectionTime = inspectionTime ? moment(inspectionTime) : null;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label className="ui-label">考核时间</label>
                    <MonthPicker
                        style={{width:90}}
                        format={monthFormat}
                        value={newInspectionTime}
                        placeholder="请选择"
                        allowClear={false}
                        disabledDate={this.disabledDate}
                        onChange={(date, dateString) => this.handleDatePickerChange(date, dateString, 'inspectionTime')}
                        className="w-90-select"
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        value={userCompellation}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                    />
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    {
                        canSynchronize ?
                            <Button type="primary" onClick={synchronizeUser} style={{ background: '#62cf96', border: '1px solid #00a854' }}>同步人员</Button>
                        :
                            <Button disabled={true}>同步人员</Button>
                    }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

class Contribute extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        data: [],
        config: {},
        canSynchronize: false,
    }

    // 同步人员
    synchronizeUser = () => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.user.createLeaderMemberUser,
            data: {},
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryLeaderMemberScoreGradeList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { data = {}, datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;
                const { canSynchronize } = data;

                this.setState({
                    data: datas,
                    pagination,
                    config: data,
                    loading: false,
                    canSynchronize: canSynchronize == 'true',
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = searchParams => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { pagination, sortParams, searchParams } = this.state;
        ExportUtil.export({ ...sortParams, ...searchParams }, pagination, API_URL.user.exportLeaderMemberScoreGradeList);
    }

    getDateRender = text => text ? text.slice(0, 7) : ''

    getColumns = () => {
        const { config: { canEdit } } = this.state;
        const columns = [{
            title: '考核时间',
            dataIndex: 'inspectionTime',
            key: 'inspectionTime',
            width: 85,
            render: this.getDateRender,
        }, {
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
            sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }, {
            title: '鼓励团队成员',
            dataIndex: 'leaderEncourageTeamMembers',
            key: 'leaderEncourageTeamMembers',
        }, {
            title: '正能量宣传',
            dataIndex: 'leaderPositiveEnergyPromotion',
            key: 'leaderPositiveEnergyPromotion',
        }, {
            title: '团队凝聚力',
            dataIndex: 'leaderTeamUnity',
            key: 'leaderTeamUnity',
        }, {
            title: '合计',
            dataIndex: 'supervisorTeamContribute',
            key: 'supervisorTeamContribute',
        }, {
            title: '主管总结性评语',
            dataIndex: 'summaryRemark',
            key: 'summaryRemark',
            width: 200,
        }, {
            title: '评价人',
            dataIndex: 'appraiseUser',
            key: 'appraiseUser',
            render: (text, record) => {
                const { appraiseCompellation, appraiseCode } = record;
                return (
                    appraiseCompellation ?
                        <span>
                            {appraiseCompellation}
                            <br />
                            { appraiseCode ? `(${appraiseCode})` : '' }
                        </span>
                    :
                        ''
                )
            }
        }, {
            title: '评价时间',
            dataIndex: 'appraiseTime',
            key: 'appraiseTime',
            width: 85,
        }];
        if (canEdit == 'true') {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 60,
                render: (text, record) => {
                    return <a onClick={() => this.updateScore(record)}>加分</a>
                }
            })
        }
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map((item, index) => ({
            index: index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    updateScore = (record) => {
        this.updateScoreRef.show(record);
    }

    render() {
        const { config, loading, pagination, canSynchronize } = this.state;
        return (
            <div>
                <Filter
                    search={this.search}
                    export={this.export}
                    canSynchronize={canSynchronize}
                    synchronizeUser={this.synchronizeUser}
                />
                <Table
                    bordered
                    loading={loading}
                    pagination={pagination}
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={row => row.index}
                    onChange={this.handleTableChange}
                />
                <UpdateScore ref={el => this.updateScoreRef = el} config={config} loadData={this.loadData} />
            </div>
        );
    }
}

export default Contribute;


// WEBPACK FOOTER //
// ./src/components/user/teamManageEvaluate/Contribute.js